/** 便签 textarea：按内容撑高，且不超过 CSS max-height（如三行上限） */
export function syncNoteTextareaHeightToContent(el: HTMLTextAreaElement | null, minPxFallback = 18): void {
  if (!el) return;
  el.style.height = 'auto';
  const maxHRaw = getComputedStyle(el).maxHeight;
  const maxPx = parseFloat(maxHRaw);
  const cap = Number.isFinite(maxPx) && maxPx > 0 ? maxPx : Number.POSITIVE_INFINITY;
  const minRaw = getComputedStyle(el).minHeight;
  const minPx = parseFloat(minRaw);
  const floor = Number.isFinite(minPx) && minPx > 0 ? minPx : minPxFallback;
  el.style.height = `${Math.min(Math.max(floor, el.scrollHeight), cap)}px`;
}
